module.exports = __webpack_public_path__ + "static/Wyvern-8f0a282e9411de5d357e7e7ddce38c11.jpg";